import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type CampaignSendState } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";

const initialState: CampaignSendState = {
  created: false,
  isLoading: false,
  error: undefined,
};

const campaignSendSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/send`,
  initialState,
  reducers: {
    createBegin(state: CampaignSendState) {
      state.isLoading = true;
    },
    createSuccess(state: CampaignSendState) {
      state.created = true;
      state.isLoading = false;
    },
    createFailure(state: CampaignSendState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetSendCreation(state: CampaignSendState) {
      state.created = initialState.created;
      state.isLoading = initialState.isLoading;
      state.error = initialState.error;
    },
  },
});

export const { createBegin, createSuccess, createFailure, resetSendCreation } = campaignSendSlice.actions;

export default campaignSendSlice.reducer;
